import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Modal from 'react-modal';

import Navbar from './components/Navbar';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import CareersPage from './components/CareersPage';

// College Portal (Unified Registration, Login, and Password Change)
import CollegeLogin from './components/College/CollegeLogin';
import CollegeDetailsForm from './components/College/CollegeDetailsForm';
import CollegeDashboard from './components/College/CollegeDashboard';

// Candidate Portal (Unified Registration, Login, and Password Change)
import CandidateLogin from './components/Candidate/CandidateLogin';
import CandidateDetailsForm from './components/Candidate/CandidateDetailsForm';
import CandidateDashboard from './components/Candidate/CandidateDashboard';

// Recruiter Portal
import RecruiterAuth from './components/Recruiter/RecruiterAuth';
import RecruitmentDashboard from './components/Recruiter/RecruitmentDashboard';

// Customer Portal
import CustomerAuth from './components/Customer/CustomerAuth';
import CustomerDashboard from './components/Customer/CustomerDashboard';

// Admin Portal
import AdminAuth from './components/Admin/AdminAuth';
import AdminDashboard from './components/Admin/AdminDashboard';

// Informational Pages
import AboutUs from './components/AboutUs';
import FAQ from './components/FAQ';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import './styles/App.css';

// Careers / Public Portal
import CareersAuth from './components/CareersAuth';
import CareersDashboard from './components/CareersDashboard'; // <--- NEW IMPORT ADDED HERE!


Modal.setAppElement('#root'); 

function AppContent() {
  const location = useLocation();

  // Navbar is displayed on general landing and info pages
  const showNavbarRoutes = ["/", "/home", "/careers", "/AboutUs", "/faq", "/privacy-policy", "/terms-conditions"];
  const showNavbar = showNavbarRoutes.includes(location.pathname);

  return (
    <>
      {showNavbar && <Navbar />} 
      <Routes>
        {/* --- PUBLIC LANDING & INFO --- */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />

        {/* --- UNIFIED COLLEGE PORTAL ROUTES --- */}
        <Route path="/college-login" element={<CollegeLogin />} />
        <Route path="/college-register" element={<CollegeLogin />} />
        <Route path="/college-forgot-password" element={<CollegeLogin />} />
        <Route path="/college-details-form" element={<CollegeDetailsForm />} />
        <Route path="/college-dashboard" element={<CollegeDashboard />} />

        {/* --- UNIFIED CANDIDATE PORTAL ROUTES --- */}
        <Route path="/candidate-login" element={<CandidateLogin />} />
        <Route path="/candidate-register" element={<CandidateLogin />} />
        <Route path="/candidate-forgot-password" element={<CandidateLogin />} />
        <Route path="/candidate-details-form" element={<CandidateDetailsForm />} />
        <Route path="/candidate-dashboard" element={<CandidateDashboard />} />

        {/* --- RECRUITER & CUSTOMER DASHBOARDS --- */}
        <Route path="/recruiter-login" element={<RecruiterAuth />} />
        <Route path="/recruitment-dashboard" element={<RecruitmentDashboard />} />
        <Route path="/customerLogin" element={<CustomerAuth />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />

        {/* --- SYSTEM ADMIN --- */}
        <Route path="/admin-login" element={<AdminAuth />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        {/* --- CAREERS PAGE AUTH & DASHBOARD --- */}
        <Route path="/login" element={<CareersAuth />} />
        <Route path="/careers-dashboard" element={<CareersDashboard />} /> {/* <--- NEW ROUTE ADDED HERE! */}
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;